var getLocale = function(id){
	var result = '';

	if (typeof web.lang !== undefined) {
		result = locale[web.lang][id];
	}
	return result;
};
var getLocaleVariant = function(id, value) {
	var localeItem = getLocale(id);

	if (value == 1)
		return localeItem[0];
	else if (value > 1 && value < 5)
		return localeItem[1];
	else
		return localeItem[2];
};

var locale = [];
locale['cs'] = [];
locale['en'] = [];

locale['cs']['dateFormat'] = 'd. m. yyyy';
locale['cs']['czk'] = 'Kč';
locale['cs']['month-short'] = 'měs.';
locale['cs']['years'] = new Array('rok','roky','let');
locale['cs']['months'] = new Array('měsíc','měsíce','měsíců');
locale['cs']['close'] = 'Zavřít';

locale['cs']['hs.loadingText']='Nahrává se...';
locale['cs']['hs.loadingTitle']='Kliknutím zrušit';
locale['cs']['hs.focusTitle']='Kliknutím přenést vpřed';
locale['cs']['hs.fullExpandTitle']='Zvětšit na původní velikost (F)';
locale['cs']['hs.previousText']='Předchozí';
locale['cs']['hs.nextText']='Následující';
locale['cs']['hs.moveText']='Přesunout';
locale['cs']['hs.closeText']='Zavřít';
locale['cs']['hs.closeTitle']='Zavřít (ESC)';
locale['cs']['hs.resizeTitle']='Změnit velikost';
locale['cs']['hs.playText']='Spustit slideshow';
locale['cs']['hs.playTitle']='Spustit slideshow (mezerník)';
locale['cs']['hs.pauseText']='Pauza';
locale['cs']['hs.pauseTitle']='Pauza (mezerník)';
locale['cs']['hs.previousTitle']='Předchozí (levá šipka)';
locale['cs']['hs.nextTitle']='Následující (pravá šipka)';
locale['cs']['hs.moveTitle']='Přesunout';
locale['cs']['hs.fullExpandText']='Plná velikost';
locale['cs']['hs.number']='Obrázek %1 z %2';
locale['cs']['hs.restoreTitle']='Kliknutím zavřít obrázek, kliknutím a tažením přesunout. Šipkami přechod na předchozí a další obrázek.';





// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/locale.js